import { useQuery } from '@tanstack/react-query';
import { opportunityService } from '../../../services/opportunityService';

export const shortlistQueryKey = (opportunityId: number, positionId?: number) =>
    positionId != null
        ? ['opportunity', opportunityId, 'shortlist', positionId]
        : ['opportunity', opportunityId, 'shortlist'];

export const useOpportunityShortlistQuery = (opportunityId: number, positionId?: number) =>
    useQuery({
        queryKey: shortlistQueryKey(opportunityId, positionId),
        queryFn: () => opportunityService.getShortlist(opportunityId, positionId),
        staleTime: 60_000,
        enabled: opportunityId > 0,
    });
